import { cloneElement, useEffect, useState } from "react";
import { FiLogOut } from "react-icons/fi";
import { IoChevronForward } from "react-icons/io5";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { routes } from "routes";
import {
  setSideBarCollapsed,
  signOutRequest,
} from "../../../store/auth/authSlice";
import { Button } from "../Button";
import classes from "./SideBar.module.css";
import { Logo } from "@/constant/imagePath";

const SideBar = ({ isCollapsed, isMobile }) => {
  const [popper, setPopper] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const HandleSubmitSignOut = () => {
    dispatch(signOutRequest());
    navigate("/login");
  };

  return (
    <div className={classes?.mainContainer}>
      <div className={classes.logoContainer}>
        {isCollapsed ? (
          <img src={Logo} alt="abc" />
        ) : (
          <img src={Logo} alt="abc" />
        )}
      </div>
      <div
        className={classes.toggler}
        onClick={() => {
          dispatch(setSideBarCollapsed(!isCollapsed));
        }}
      >
        <IoChevronForward className={!isCollapsed ? classes.toggleIcon : ""} />
      </div>
      <div
        className={[
          classes.itemsContainer,
          isCollapsed && classes.isCollapsedContainer,
          isMobile && classes.isMobile,
        ].join(" ")}
      >
        {isCollapsed && popper && (
          <span
            className={classes.popper}
            style={{ top: `${popper.pos + 16}px` }}
          >
            {popper.value}
          </span>
        )}
        <div
          className={[
            classes.items,
            isCollapsed && classes.itemsCollapsed,
          ].join(" ")}
        >
          {routes
            .filter((e) => e.showInSidebar)
            .map((item, index) => {
              return (
                <RenderItem
                  icon={item?.icon}
                  title={item?.title}
                  path={item?.path}
                  subMenu={
                    item?.subMenu && item.subMenu.filter((e) => e.showInSidebar)
                  }
                  isCollapsed={isCollapsed}
                  key={index}
                  setPopper={setPopper}
                />
              );
            })}
        </div>
        <div className={classes.logout_btn}>
          <Button
            className={isCollapsed && classes.collapsed_btn}
            variant="primary"
            onClick={HandleSubmitSignOut}
          >
            <FiLogOut />
            {!isCollapsed && "Logout"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SideBar;

const RenderItem = ({
  icon,
  title,
  subMenu = [],
  path,
  isCollapsed,
  setPopper,
}) => {
  const pathname = useLocation()?.pathname;
  const active = pathname === path ? true : false;
  const [subnav, setSubnav] = useState(false);
  const subActive = subMenu.find((item, index) => item?.path == pathname);
  const showSubnav = () => setSubnav(!subnav);
  useEffect(() => {
    const allPaths = subMenu.map((item) => item?.path);
    if (allPaths.includes(pathname)) {
      setSubnav(true);
    }
  }, []);

  return (
    <>
      <Link
        className={[
          classes?.listItemContainer,
          active && classes?.active,
          subActive && classes?.subActive,
          subnav && classes?.subnav,
          isCollapsed ? classes.isCollapsed : "",
        ].join(" ")}
        onMouseEnter={(e) => {
          setPopper({
            pos: e.target.offsetTop - e.target.parentElement.scrollTop,
            value: title,
          });
        }}
        onMouseLeave={(e) => {
          setPopper(null);
        }}
        data-title={title}
        to={subMenu?.length > 0 ? "#" : path}
        onClick={() => {
          if (subMenu?.length > 0) {
            showSubnav(!subnav);
          }
        }}
      >
        {icon
          ? cloneElement(icon, {
              size: 20,
              className: classes?.icon,
            })
          : null}
        {!isCollapsed && <span>{title}</span>}
        {subMenu?.length > 0 &&
          !isCollapsed &&
          (subnav ? (
            <TiArrowSortedDown size={22} className={classes?.dropDownIcon} />
          ) : (
            <TiArrowSortedUp size={22} className={classes?.dropDownIcon} />
          ))}
      </Link>

      {subnav && (
        <div
          className={[
            classes?.subMenu,
            isCollapsed ? classes.submenuIsCollapsed : "",
          ].join(" ")}
        >
          {subMenu.map((item, index) => {
            return (
              <Link
                className={[
                  classes?.innerItemContainer,
                  isCollapsed
                    ? classes.isCollapsed
                    : classes?.notCollapsedInnercontainer,
                  subActive?.path === item?.path && classes?.innerItemSubActive,
                ].join(" ")}
                onMouseEnter={(e) => {
                  setPopper({
                    pos:
                      e.target.offsetTop +
                      e.target.parentElement.offsetTop -
                      e.target.parentElement.parentElement.scrollTop -
                      10,
                    value: item?.title,
                  });
                }}
                onMouseLeave={(e) => {
                  setPopper(null);
                }}
                data-title={item?.title}
                key={index}
                to={item?.path}
              >
                {item?.icon &&
                  isCollapsed &&
                  cloneElement(item?.icon, {
                    size: 20,
                    color: "var(--text-primary)",
                    className: classes.innerIcon,
                  })}

                {!isCollapsed && <span>{item?.title}</span>}
              </Link>
            );
          })}
        </div>
      )}
    </>
  );
};
